export const messages = {
  en: {
feeConfigManage: {
      selectFeeTypeFirst: 'Please select the fee type on the left first',
      search: {
        title: 'Search Conditions',
        hide: 'Hide',
        more: 'More',
        configIdPlaceholder: 'Please enter fee item ID',
        feeNamePlaceholder: 'Please enter fee item name',
        feeFlagPlaceholder: 'Please select fee flag',
        paymentCdPlaceholder: 'Please select payment type',
        deductFromPlaceholder: 'Please select account deduction',
        isDefaultPlaceholder: 'Please select default fee',
        all: 'All',
        query: 'Search',
        reset: 'Reset'
      },
      list: {
        title: 'Fee Items',
        document: 'Document',
        add: 'Add',
        explanation1: 'Fee Flag: Divided into periodic fees and one-time fees. Periodic fees are continuous charges like property fees that are collected annually, so property fees are recommended to use periodic fees;',
        explanation2: 'One-time fees indicate that the fee is only charged once, such as a deposit, and need to be manually created on the property for the next charge;',
        explanation3: 'Payment Type: Divided into prepaid and postpaid. Prepaid means the fee is collected in advance, postpaid means it is collected afterwards;'
      },
      table: {
        number: 'Number',
        feeType: 'Fee Type',
        feeName: 'Fee Item',
        feeFlag: 'Fee Flag',
        paymentType: 'Payment Type',
        paymentCycle: 'Payment Cycle (months)',
        formula: 'Formula',
        unitPrice: 'Unit Price (yuan)',
        additionalAmount: 'Additional/Fixed Fee (yuan)',
        billing: 'Billing',
        status: 'Status',
        operation: 'Operation',
        edit: 'Edit',
        discount: 'Discount',
        delete: 'Delete',
        detail: 'Detail'
      },
      loadDictError: 'Failed to load dictionary data',
      queryError: 'Failed to query fee configuration'
    },
    feeTypeTree: {
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      loadError: 'Failed to load fee type tree'
    },
    addFeeType: {
      title: 'Add Fee Type',
      typeName: 'Type Name',
      monthBase: 'Monthly Base',
      typeNamePlaceholder: 'Required, please enter type name',
      monthBasePlaceholder: 'Required, please enter monthly base',
      cancel: 'Cancel',
      save: 'Save',
      validate: {
        typeNameRequired: 'Type name cannot be empty',
        typeNameMaxLength: 'Type name cannot exceed 100 characters',
        monthBaseRequired: 'Monthly base cannot be empty',
        monthBaseFormat: 'Monthly base format error'
      },
      saveSuccess: 'Fee type added successfully',
      saveError: 'Failed to add fee type'
    },
    deleteFeeType: {
      title: 'Confirm Operation',
      confirmMessage: 'Confirm to delete fee type?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete!',
      deleteSuccess: 'Fee type deleted successfully',
      deleteError: 'Failed to delete fee type'
    },
    addFeeConfig: {
      title: 'Add Fee Configuration',
      feeType: 'Fee Type',
      feeName: 'Fee Item',
      feeFlag: 'Fee Flag',
      paymentType: 'Payment Type',
      paymentCycle: 'Payment Cycle (months)',
      prepaymentPeriod: 'Generate Cycles',
      toYearEnd: 'To Dec 31',
      unit: 'Unit',
      billing: 'Billing',
      mobilePayment: 'Mobile Payment',
      roundingMethod: 'Rounding Method',
      decimalPlaces: 'Decimal Places',
      status: 'Status',
      computingFormula: 'Computing Formula',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional Fee',
      scaleFactor: 'Scale Factor',
      fixedFee: 'Fixed Fee',
      formula: 'Formula',
      explanation: 'Explanation',
      explanationC: 'Represents community area corresponding to the property',
      explanationF: 'Represents building area corresponding to the property',
      explanationU: 'Represents unit area corresponding to the property',
      explanationR: 'Represents property area',
      explanationX: 'Represents property fee coefficient (configured in property management)',
      explanationL: 'Represents number of floors',
      explanationRLPC: 'Represents number of residents',
      example: 'Example: Elevator usage fee (number of floors - 5) * unit price per floor + base fee',
      feeTypePlaceholder: 'Required, please select fee type',
      feeNamePlaceholder: 'Required, please enter fee item name',
      feeFlagPlaceholder: 'Required, please select fee flag',
      paymentTypePlaceholder: 'Required, please select payment type',
      paymentCyclePlaceholder: 'Required, please enter payment cycle',
      prepaymentPeriodPlaceholder: 'Required, please select generate cycles',
      unitPlaceholder: 'Required, please enter unit (e.g., yuan)',
      computingFormulaPlaceholder: 'Required, please select computing formula',
      unitPricePlaceholder: 'Required, please enter unit price',
      additionalAmountPlaceholder: 'Required, please enter additional fee',
      formulaPlaceholder: 'Required, please enter formula',
      currentMonth: 'Current Month',
      lastMonth: 'Last Month',
      nextMonth: 'Next Month',
      enable: 'Enable',
      disable: 'Disable',
      roundHalfUp: 'Round Half Up',
      roundUp: 'Round Up',
      roundDown: 'Round Down',
      integer: 'Integer',
      oneDecimal: '1 decimal',
      twoDecimals: '2 decimals',
      threeDecimals: '3 decimals',
      fourDecimals: '4 decimals',
      fiveDecimals: '5 decimals',
      sixDecimals: '6 decimals',
      cancel: 'Cancel',
      save: 'Save',
      validate: {
        feeTypeRequired: 'Fee type cannot be empty',
        feeNameRequired: 'Fee item name cannot be empty',
        feeNameLength: 'Fee item name must be between 1-100 characters',
        feeFlagRequired: 'Fee flag cannot be empty',
        paymentTypeRequired: 'Payment type cannot be empty',
        paymentCycleRequired: 'Payment cycle cannot be empty',
        paymentCycleNumber: 'Payment cycle must be a number (months)',
        prepaymentPeriodNumber: 'Generate cycles must be a number',
        computingFormulaRequired: 'Computing formula cannot be empty',
        unitPriceFormat: 'Unit price format error, e.g., 1.5000',
        additionalAmountFormat: 'Additional amount format error'
      },
      loadDictError: 'Failed to load dictionary data',
      saveSuccess: 'Fee configuration added successfully',
      saveError: 'Failed to add fee configuration'
    },
    editFeeConfig: {
      title: 'Edit Fee Configuration',
      feeType: 'Fee Type',
      feeName: 'Fee Item',
      feeFlag: 'Fee Flag',
      paymentType: 'Payment Type',
      paymentCycle: 'Payment Cycle (months)',
      prepaymentPeriod: 'Generate Cycles',
      toYearEnd: 'To Dec 31',
      unit: 'Unit',
      billing: 'Billing',
      mobilePayment: 'Mobile Payment',
      roundingMethod: 'Rounding Method',
      decimalPlaces: 'Decimal Places',
      status: 'Status',
      computingFormula: 'Computing Formula',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional Fee',
      scaleFactor: 'Scale Factor',
      fixedFee: 'Fixed Fee',
      formula: 'Formula',
      explanation: 'Explanation',
      explanationC: 'Represents community area corresponding to the property',
      explanationF: 'Represents building area corresponding to the property',
      explanationU: 'Represents unit area corresponding to the property',
      explanationR: 'Represents property area',
      explanationX: 'Represents property fee coefficient (configured in property management)',
      explanationL: 'Represents number of floors',
      explanationRLPC: 'Represents number of residents',
      example: 'Example: Elevator usage fee (number of floors - 5) * unit price per floor + base fee',
      feeTypePlaceholder: 'Required, please select fee type',
      feeNamePlaceholder: 'Required, please enter fee item name',
      feeFlagPlaceholder: 'Required, please select fee flag',
      paymentTypePlaceholder: 'Required, please select payment type',
      paymentCyclePlaceholder: 'Required, please enter payment cycle',
      prepaymentPeriodPlaceholder: 'Required, please select generate cycles',
      unitPlaceholder: 'Required, please enter unit (e.g., yuan)',
      billingPlaceholder: 'Required, please select billing',
      computingFormulaPlaceholder: 'Required, please select computing formula',
      unitPricePlaceholder: 'Required, please enter unit price',
      additionalAmountPlaceholder: 'Required, please enter additional fee',
      formulaPlaceholder: 'Required, please enter formula',
      currentMonth: 'Current Month',
      lastMonth: 'Last Month',
      nextMonth: 'Next Month',
      enable: 'Enable',
      disable: 'Disable',
      disableAndEnd: 'Disable and end fee',
      roundHalfUp: 'Round Half Up',
      roundUp: 'Round Up',
      roundDown: 'Round Down',
      integer: 'Integer',
      oneDecimal: '1 decimal',
      twoDecimals: '2 decimals',
      threeDecimals: '3 decimals',
      fourDecimals: '4 decimals',
      fiveDecimals: '5 decimals',
      sixDecimals: '6 decimals',
      cancel: 'Cancel',
      save: 'Save',
      validate: {
        feeTypeRequired: 'Fee type cannot be empty',
        feeNameRequired: 'Fee item name cannot be empty',
        feeNameLength: 'Fee item name must be between 1-100 characters',
        feeFlagRequired: 'Fee flag cannot be empty',
        paymentTypeRequired: 'Payment type cannot be empty',
        paymentCycleNumber: 'Payment cycle must be a number (months)',
        prepaymentPeriodNumber: 'Generate cycles must be a number',
        prepaymentPeriodRequired: 'Generate cycles cannot be empty',
        computingFormulaRequired: 'Computing formula cannot be empty',
        unitPriceFormat: 'Unit price format error',
        additionalAmountFormat: 'Additional amount format error',
        billingRequired: 'Billing cannot be empty'
      },
      loadDictError: 'Failed to load dictionary data',
      saveSuccess: 'Fee configuration updated successfully',
      saveError: 'Failed to update fee configuration'
    },
    deleteFeeConfig: {
      title: 'Please confirm your operation!',
      confirmMessage: 'Confirm to delete fee item?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'Fee configuration deleted successfully',
      deleteError: 'Failed to delete fee configuration'
    }
  },
zh: {
    feeConfigManage: {
      selectFeeTypeFirst: '请先选择左侧的费用类型',
      search: {
        title: '查询条件',
        hide: '隐藏',
        more: '更多',
        configIdPlaceholder: '请输入费用项ID',
        feeNamePlaceholder: '请输入收费项目',
        feeFlagPlaceholder: '请选择费用标识',
        paymentCdPlaceholder: '请选择付费类型',
        deductFromPlaceholder: '请选择账户抵扣',
        isDefaultPlaceholder: '请选择默认费用',
        all: '全部',
        query: '查询',
        reset: '重置'
      },
      list: {
        title: '费用项',
        document: '文档',
        add: '添加',
        explanation1: '费用标识：分为周期费用和一次性费用，周期费是连续收费的费用比如物业费每年都会收取，所以物业费建议用周期费；',
        explanation2: '一次性费用表示费用只收取一次比如押金，下次收费时还需要手工创建到房屋上；',
        explanation3: '付费类型：分为预付费和后付费，预付费表示费用提前收费 后付费表示之后收取；'
      },
      table: {
        number: '编号',
        feeType: '费用类型',
        feeName: '收费项目',
        feeFlag: '费用标识',
        paymentType: '付费类型',
        paymentCycle: '缴费周期(单位:月)',
        formula: '公式',
        unitPrice: '计费单价(单位:元)',
        additionalAmount: '附加/固定费用(单位:元)',
        billing: '计费',
        status: '状态',
        operation: '操作',
        edit: '修改',
        discount: '折扣',
        delete: '删除',
        detail: '详情'
      },
      loadDictError: '加载字典数据失败',
      queryError: '查询费用配置失败'
    },
    feeTypeTree: {
      add: '添加',
      edit: '修改',
      delete: '删除',
      loadError: '加载费用类型树失败'
    },
    addFeeType: {
      title: '添加费用类型',
      typeName: '类型名称',
      monthBase: '月基数',
      typeNamePlaceholder: '必填，请填写类型名称',
      monthBasePlaceholder: '必填，请填写月基数',
      cancel: '取消',
      save: '保存',
      validate: {
        typeNameRequired: '类型名称不能为空',
        typeNameMaxLength: '类型名称不能超过100个字符',
        monthBaseRequired: '月基数不能为空',
        monthBaseFormat: '月基数格式错误'
      },
      saveSuccess: '费用类型添加成功',
      saveError: '添加费用类型失败'
    },
    deleteFeeType: {
      title: '请确认您的操作!',
      confirmMessage: '确定删除费用类型？',
      cancel: '点错了',
      confirm: '确认删除!',
      deleteSuccess: '费用类型删除成功',
      deleteError: '删除费用类型失败'
    },
    addFeeConfig: {
      title: '添加费用配置',
      feeType: '费用类型',
      feeName: '收费项目',
      feeFlag: '费用标识',
      paymentType: '付费类型',
      paymentCycle: '缴费周期(单位:月)',
       prepaymentPeriod: '生成期数',
       toYearEnd: '到当年12月',
      unit: '单位',
      billing: '计费',
      mobilePayment: '手机缴费',
      roundingMethod: '进位方式',
      decimalPlaces: '保留小数位',
      status: '状态',
      computingFormula: '计算公式',
      unitPrice: '计费单价',
      additionalFee: '附加费用',
      scaleFactor: '比例系数',
      fixedFee: '固定费用',
      formula: '公式',
      explanation: '说明',
      explanationC: '代表房屋对应小区面积',
      explanationF: '代表房屋对应楼栋面积',
      explanationU: '代表房屋对应单元面积',
      explanationR: '代表房屋面积',
      explanationX: '代表房屋收费系数（房屋管理中配置）',
      explanationL: '代表房屋层数',
      explanationRLPC: '代表房屋人数',
      example: '举例：电梯使用费 (层数-5)*每层单价+基础费用',
      feeTypePlaceholder: '必填，请选择费用类型',
      feeNamePlaceholder: '必填，请填写收费项目',
      feeFlagPlaceholder: '必填，请选择费用标识',
      paymentTypePlaceholder: '必填，请选择付费类型',
      paymentCyclePlaceholder: '必填，请填写缴费周期',
       prepaymentPeriodPlaceholder: '必填，请选择生成期数',
      unitPlaceholder: '必填，请填写单位（如：元）',
      computingFormulaPlaceholder: '必填，请选择计算公式',
      unitPricePlaceholder: '必填，请填写计费单价',
      additionalAmountPlaceholder: '必填，请填写附加费用',
      formulaPlaceholder: '必填，请填写公式',
      currentMonth: '当月',
      lastMonth: '上月',
      nextMonth: '下月',
      enable: '启用',
      disable: '停用',
      roundHalfUp: '四舍五入',
      roundUp: '向上进位',
      roundDown: '向下进位',
      integer: '取整',
      oneDecimal: '1位',
      twoDecimals: '2位',
      threeDecimals: '3位',
      fourDecimals: '4位',
      fiveDecimals: '5位',
      sixDecimals: '6位',
      cancel: '取消',
      save: '保存',
      validate: {
        feeTypeRequired: '费用类型不能为空',
        feeNameRequired: '收费项目不能为空',
        feeNameLength: '收费项目长度必须在1-100个字符之间',
        feeFlagRequired: '费用标识不能为空',
        paymentTypeRequired: '付费类型不能为空',
        paymentCycleRequired: '缴费周期不能为空',
        paymentCycleNumber: '缴费周期必须为数字（单位月）',
         prepaymentPeriodNumber: '生成期数必须为数字',
        computingFormulaRequired: '计算公式不能为空',
        unitPriceFormat: '计费单价格式错误，如1.5000',
        additionalAmountFormat: '附加费用格式错误'
      },
      loadDictError: '加载字典数据失败',
      saveSuccess: '费用配置添加成功',
      saveError: '添加费用配置失败'
    },
    editFeeConfig: {
      title: '修改费用配置',
      feeType: '费用类型',
      feeName: '收费项目',
      feeFlag: '费用标识',
      paymentType: '付费类型',
      paymentCycle: '缴费周期(单位:月)',
       prepaymentPeriod: '生成期数',
       toYearEnd: '到当年12月',
      unit: '单位',
      billing: '计费',
      mobilePayment: '手机缴费',
      roundingMethod: '进位方式',
      decimalPlaces: '保留小数位',
      status: '状态',
      computingFormula: '计算公式',
      unitPrice: '计费单价',
      additionalFee: '附加费用',
      scaleFactor: '比例系数',
      fixedFee: '固定费用',
      formula: '公式',
      explanation: '说明',
      explanationC: '代表房屋对应小区面积',
      explanationF: '代表房屋对应楼栋面积',
      explanationU: '代表房屋对应单元面积',
      explanationR: '代表房屋面积',
      explanationX: '代表房屋收费系数（房屋管理中配置）',
      explanationL: '代表房屋层数',
      explanationRLPC: '代表房屋人数',
      example: '举例：电梯使用费 (层数-5)*每层单价+基础费用',
      feeTypePlaceholder: '必填，请选择费用类型',
      feeNamePlaceholder: '必填，请填写收费项目',
      feeFlagPlaceholder: '必填，请选择费用标识',
      paymentTypePlaceholder: '必填，请选择付费类型',
      paymentCyclePlaceholder: '必填，请填写缴费周期',
       prepaymentPeriodPlaceholder: '必填，请选择生成期数',
      unitPlaceholder: '必填，请填写单位（如：元）',
      billingPlaceholder: '必填，请选择计费',
      computingFormulaPlaceholder: '必填，请选择计算公式',
      unitPricePlaceholder: '必填，请填写计费单价',
      additionalAmountPlaceholder: '必填，请填写附加费用',
      formulaPlaceholder: '必填，请填写公式',
      currentMonth: '当月',
      lastMonth: '上月',
      nextMonth: '下月',
      enable: '启用',
      disable: '停用',
      disableAndEnd: '停用并结束费用',
      roundHalfUp: '四舍五入',
      roundUp: '向上进位',
      roundDown: '向下进位',
      integer: '取整',
      oneDecimal: '1位',
      twoDecimals: '2位',
      threeDecimals: '3位',
      fourDecimals: '4位',
      fiveDecimals: '5位',
      sixDecimals: '6位',
      cancel: '取消',
      save: '保存',
      validate: {
        feeTypeRequired: '费用类型不能为空',
        feeNameRequired: '收费项目不能为空',
        feeNameLength: '收费项目长度必须在1-100个字符之间',
        feeFlagRequired: '费用标识不能为空',
        paymentTypeRequired: '付费类型不能为空',
        paymentCycleNumber: '缴费周期必须为数字（单位月）',
         prepaymentPeriodNumber: '生成期数必须为数字',
         prepaymentPeriodRequired: '生成期数不能为空',
        computingFormulaRequired: '计算公式不能为空',
        unitPriceFormat: '计费单价格式错误',
        additionalAmountFormat: '附加费用格式错误',
        billingRequired: '计费不能为空'
      },
      loadDictError: '加载字典数据失败',
      saveSuccess: '费用配置修改成功',
      saveError: '修改费用配置失败'
    },
deleteFeeConfig: {
      title: '请确认您的操作!',
      confirmMessage: '确定删除费用项？',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '费用配置删除成功',
      deleteError: '删除费用配置失败'
    }
  },
'zh-TW': {
    feeConfigManage: {
      selectFeeTypeFirst: '請先選擇左側的費用類型',
      search: {
        title: '查詢條件',
        hide: '隱藏',
        more: '更多',
        configIdPlaceholder: '請輸入費用項ID',
        feeNamePlaceholder: '請輸入收費項目',
        feeFlagPlaceholder: '請選擇費用標識',
        paymentCdPlaceholder: '請選擇付費類型',
        deductFromPlaceholder: '請選擇帳戶抵扣',
        isDefaultPlaceholder: '請選擇預設費用',
        all: '全部',
        query: '查詢',
        reset: '重設'
      },
      list: {
        title: '費用項',
        document: '文檔',
        add: '添加',
        explanation1: '費用標識：分為週期費用和一次性費用，週期費是連續收費的費用比如物業費每年都會收取，所以物業費建議用週期費；',
        explanation2: '一次性費用表示費用只收取一次比如押金，下次收費時還需要手工創建到房屋上；',
        explanation3: '付費類型：分為預付費和後付費，預付費表示費用提前收費 後付費表示之後收取；'
      },
      table: {
        number: '編號',
        feeType: '費用類型',
        feeName: '收費項目',
        feeFlag: '費用標識',
        paymentType: '付費類型',
        paymentCycle: '繳費週期(單位:月)',
        formula: '公式',
        unitPrice: '計費單價(單位:元)',
        additionalAmount: '附加/固定費用(單位:元)',
        billing: '計費',
        status: '狀態',
        operation: '操作',
        edit: '修改',
        discount: '折扣',
        delete: '刪除',
        detail: '詳情'
      },
      loadDictError: '載入字典數據失敗',
      queryError: '查詢費用配置失敗'
    },
    feeTypeTree: {
      add: '添加',
      edit: '修改',
      delete: '刪除',
      loadError: '載入費用類型樹失敗'
    },
    addFeeType: {
      title: '添加費用類型',
      typeName: '類型名稱',
      monthBase: '月基數',
      typeNamePlaceholder: '必填，請填寫類型名稱',
      monthBasePlaceholder: '必填，請填寫月基數',
      cancel: '取消',
      save: '保存',
      validate: {
        typeNameRequired: '類型名稱不能為空',
        typeNameMaxLength: '類型名稱不能超過100個字符',
        monthBaseRequired: '月基數不能為空',
        monthBaseFormat: '月基數格式錯誤'
      },
      saveSuccess: '費用類型添加成功',
      saveError: '添加費用類型失敗'
    },
    deleteFeeType: {
      title: '請確認您的操作!',
      confirmMessage: '確定刪除費用類型？',
      cancel: '點錯了',
      confirm: '確認刪除!',
      deleteSuccess: '費用類型刪除成功',
      deleteError: '刪除費用類型失敗'
    },
    addFeeConfig: {
      title: '添加費用配置',
      feeType: '費用類型',
      feeName: '收費項目',
      feeFlag: '費用標識',
      paymentType: '付費類型',
      paymentCycle: '繳費週期(單位:月)',
       prepaymentPeriod: '生成期數',
       toYearEnd: '到當年12月',
      unit: '單位',
      billing: '計費',
      mobilePayment: '手機繳費',
      roundingMethod: '進位方式',
      decimalPlaces: '保留小數位',
      status: '狀態',
      computingFormula: '計算公式',
      unitPrice: '計費單價',
      additionalFee: '附加費用',
      scaleFactor: '比例系數',
      fixedFee: '固定費用',
      formula: '公式',
      explanation: '說明',
      explanationC: '代表房屋對應小區面積',
      explanationF: '代表房屋對應樓棟面積',
      explanationU: '代表房屋對應單元面積',
      explanationR: '代表房屋面積',
      explanationX: '代表房屋收費系數（房屋管理中配置）',
      explanationL: '代表房屋層數',
      explanationRLPC: '代表房屋人數',
      example: '舉例：電梯使用費 (層數-5)*每層單價+基礎費用',
      feeTypePlaceholder: '必填，請選擇費用類型',
      feeNamePlaceholder: '必填，請填寫收費項目',
      feeFlagPlaceholder: '必填，請選擇費用標識',
      paymentTypePlaceholder: '必填，請選擇付費類型',
      paymentCyclePlaceholder: '必填，請填寫繳費週期',
       prepaymentPeriodPlaceholder: '必填，請選擇生成期數',
      unitPlaceholder: '必填，請填寫單位（如：元）',
      computingFormulaPlaceholder: '必填，請選擇計算公式',
      unitPricePlaceholder: '必填，請填寫計費單價',
      additionalAmountPlaceholder: '必填，請填寫附加費用',
      formulaPlaceholder: '必填，請填寫公式',
      currentMonth: '當月',
      lastMonth: '上月',
      nextMonth: '下月',
      enable: '啟用',
      disable: '停用',
      roundHalfUp: '四捨五入',
      roundUp: '向上進位',
      roundDown: '向下進位',
      integer: '取整',
      oneDecimal: '1位',
      twoDecimals: '2位',
      threeDecimals: '3位',
      fourDecimals: '4位',
      fiveDecimals: '5位',
      sixDecimals: '6位',
      cancel: '取消',
      save: '保存',
      validate: {
        feeTypeRequired: '費用類型不能為空',
        feeNameRequired: '收費項目不能為空',
        feeNameLength: '收費項目長度必須在1-100個字符之間',
        feeFlagRequired: '費用標識不能為空',
        paymentTypeRequired: '付費類型不能為空',
        paymentCycleRequired: '繳費週期不能為空',
        paymentCycleNumber: '繳費週期必須為數字（單位月）',
         prepaymentPeriodNumber: '生成期數必須為數字',
        computingFormulaRequired: '計算公式不能為空',
        unitPriceFormat: '計費單價格式錯誤，如1.5000',
        additionalAmountFormat: '附加費用格式錯誤'
      },
      loadDictError: '載入字典數據失敗',
      saveSuccess: '費用配置添加成功',
      saveError: '添加費用配置失敗'
    },
    editFeeConfig: {
      title: '修改費用配置',
      feeType: '費用類型',
      feeName: '收費項目',
      feeFlag: '費用標識',
      paymentType: '付費類型',
      paymentCycle: '繳費週期(單位:月)',
       prepaymentPeriod: '生成期數',
       toYearEnd: '到當年12月',
      unit: '單位',
      billing: '計費',
      mobilePayment: '手機繳費',
      roundingMethod: '進位方式',
      decimalPlaces: '保留小數位',
      status: '狀態',
      computingFormula: '計算公式',
      unitPrice: '計費單價',
      additionalFee: '附加費用',
      scaleFactor: '比例系數',
      fixedFee: '固定費用',
      formula: '公式',
      explanation: '說明',
      explanationC: '代表房屋對應小區面積',
      explanationF: '代表房屋對應樓棟面積',
      explanationU: '代表房屋對應單元面積',
      explanationR: '代表房屋面積',
      explanationX: '代表房屋收費系數（房屋管理中配置）',
      explanationL: '代表房屋層數',
      explanationRLPC: '代表房屋人數',
      example: '舉例：電梯使用費 (層數-5)*每層單價+基礎費用',
      feeTypePlaceholder: '必填，請選擇費用類型',
      feeNamePlaceholder: '必填，請填寫收費項目',
      feeFlagPlaceholder: '必填，請選擇費用標識',
      paymentTypePlaceholder: '必填，請選擇付費類型',
      paymentCyclePlaceholder: '必填，請填寫繳費週期',
       prepaymentPeriodPlaceholder: '必填，請選擇生成期數',
      unitPlaceholder: '必填，請填寫單位（如：元）',
      billingPlaceholder: '必填，請選擇計費',
      computingFormulaPlaceholder: '必填，請選擇計算公式',
      unitPricePlaceholder: '必填，請填寫計費單價',
      additionalAmountPlaceholder: '必填，請填寫附加費用',
      formulaPlaceholder: '必填，請填寫公式',
      currentMonth: '當月',
      lastMonth: '上月',
      nextMonth: '下月',
      enable: '啟用',
      disable: '停用',
      disableAndEnd: '停用並結束費用',
      roundHalfUp: '四捨五入',
      roundUp: '向上進位',
      roundDown: '向下進位',
      integer: '取整',
      oneDecimal: '1位',
      twoDecimals: '2位',
      threeDecimals: '3位',
      fourDecimals: '4位',
      fiveDecimals: '5位',
      sixDecimals: '6位',
      cancel: '取消',
      save: '保存',
      validate: {
        feeTypeRequired: '費用類型不能為空',
        feeNameRequired: '收費項目不能為空',
        feeNameLength: '收費項目長度必須在1-100個字符之間',
        feeFlagRequired: '費用標識不能為空',
        paymentTypeRequired: '付費類型不能為空',
        paymentCycleNumber: '繳費週期必須為數字（單位月）',
         prepaymentPeriodNumber: '生成期數必須為數字',
         prepaymentPeriodRequired: '生成期數不能為空',
        computingFormulaRequired: '計算公式不能為空',
        unitPriceFormat: '計費單價格式錯誤',
        additionalAmountFormat: '附加費用格式錯誤',
        billingRequired: '計費不能為空'
      },
      loadDictError: '載入字典數據失敗',
      saveSuccess: '費用配置修改成功',
      saveError: '修改費用配置失敗'
    },
    deleteFeeConfig: {
      title: '請確認您的操作!',
      confirmMessage: '確定刪除費用項？',
      cancel: '點錯了',
      confirm: '確認刪除',
      deleteSuccess: '費用配置刪除成功',
      deleteError: '刪除費用配置失敗'
    }
  }
}